import { useEffect, useState } from "react";
import { API_TESTIMONIALS } from "../ApiEndPoints";
import AxiosClient from "../client/AxiosClient";
import Loader from "../component/Loader";
import TestimonialTile from "../component/TestimonialTile";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import TestimonialSlide from "../component/TestimonialSlide";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

export default function TestimonialRow() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    AxiosClient.get(API_TESTIMONIALS)
      .then((response) => {
        setData(response.data.data);
      })
      .catch((err) => {
        console.error("Error white getting testimonials: " + err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoPlay: true,
    nextArrow: <NextArrow />,
    prevArrow: <PreviousArrow />,
    autoplay: true,

    autoplaySpeed: 3000,

    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };

  return (
    <section className="bg-white">
      <div className="container">
        <h2 className="sec-title text-center">From the IALM community</h2>
        <h3 className="sec-title-sm text-center fw-500 mb-5">
          2,30000+ Satisfied IALM students
        </h3>

        <div className="row justify-content-center">
          {loading ? (
            <div className="col-12 text-center">
              <Loader classes="text-primary" />
            </div>
          ) : null}

          <div className="slider-container">
            <Slider {...settings}>
              {!loading &&
                data.map((row, index) => {
                  return (
                    <div
                      className="col-md-6 col-lg-4"
                      key={`testimonial-${index}`}
                    >
                      <TestimonialSlide
                        author={row.author}
                        avatar={row.image}
                        desc={row.body}
                        designation={row.profession}
                      />
                    </div>
                  );
                })}
            </Slider>
          </div>
        </div>
      </div>
    </section>
  );
}

function NextArrow(props) {
  const { className, style, onClick } = props;

  return (
    <button
      className={`btn ${className}`}
      onClick={onClick}
      style={{ ...style }}
    >
      <FontAwesomeIcon icon={faChevronRight} />
    </button>
  );
}

function PreviousArrow(props) {
  const { className, style, onClick } = props;
  return (
    <button
      className={`btn ${className}`}
      onClick={onClick}
      style={{ ...style }}
    >
      <FontAwesomeIcon icon={faChevronLeft} />
    </button>
  );
}
